<section>
  <img class="mobydyg-logo" src="../../../assets/static/mobydyg.png" alt="MobyDyg Logo">
  <div class="card" [@slideLeft]="state" *ngIf="currentStep === 1">
    <div class="illustration">
      <img src="../../../assets/illustrations/moby-sign-in.png" />
    </div>
    <div class="form" *ngIf="!needsNewPassword; else ChangePasswordRequest" [@inOutAnimation]>
      <h2>INICIAR SESIÓN</h2>
      <form action="post" [formGroup]="signInForm">
        <div class="form-group">
          <div class="alert-span-exeption">
            <span class="error-message" *ngIf="exceptionMessage != ''" [@inOutAnimation]>{{exceptionMessage}}</span>
          </div>
          <div class="email-input">
            <input type="text" name="email" placeholder="Tu correo electrónico" class="textInput"
              formControlName="givenEmail" (input)="exceptionMessage = ''">
          </div>
          <div class="password-input">
            <input [type]="isPasswordVisible ? 'text':'password'" name="password" placeholder="Tu contraseña"
              class="textInput" formControlName="givenPassword" (input)="exceptionMessage = ''">
            <i class="password-icon" [ngClass]="isPasswordVisible ? 'hide-password' : 'show-password'"
              (click)="isPasswordVisible = !isPasswordVisible"></i>
          </div>
          <div class="checkboxContainer">
            <label for="remember-me">
              <input type="checkbox" name="remember-me" class="checkboxInput" [value]="true" id="remember-me"
                (change)="onRememberMe($event)" [checked]="rememberMe">
              <label for="remember-me" class="checkmark"></label>
              Recordar usuario
            </label>
          </div>
          <a class="a-link a-password-recovery" (click)="recoveryPassword()">Olvidé mi contraseña</a>
        </div>
        <div class="loading" *ngIf="loading">
          <div class="spinner-border" role="status"></div>
        </div>
        <div class="form-buttons d-flex-column" *ngIf="!loading">
          <button type="button" (click)="nextStep($event)" class="submit-btn">Siguiente</button><br>
        </div>
      </form>
    </div>
  </div>
  <div class="card" [@slideLeft]="state" *ngIf="currentStep === 3">
    <div class="illustration">
      <img src="../../../assets/illustrations/moby-sign-in.png" />
    </div>
    <div class="form" *ngIf="!needsNewPassword; else ChangePasswordRequest" [@inOutAnimation]>
      <h2>INICIAR SESIÓN</h2>
      <!-- <div *ngIf="isMobydygSupportEmail"> -->
      <div>
        <form action="post" [formGroup]="signInForm">
          <div class="form-group">
            <div class="alert-span-exeption">
              <span class="error-message" *ngIf="exceptionMessage != ''" [@inOutAnimation]>{{exceptionMessage}}</span>
            </div>
            <label class="label-left">Seleccione una tienda</label>
            <select class="form-select"  formControlName="givenSelectedShop">
              <option *ngFor="let shop of shops" [value]="shop.shopDomain">
                {{ shop.shopName }}
              </option>
            </select>
          </div>
          <div class="form-buttons d-flex">
            <button type="button" (click)="prevStep($event)" class="submit-btn">Anterior</button>
            <button type="button" (click)="nextStep($event)" class="submit-btn">Siguiente</button><br>
          </div>
        </form>
      </div>
      <!-- <div *ngIf="false">
        <form action="post" [formGroup]="signInForm">
          <div class="form-group">
            <div class="alert-span-exeption">
              <span class="error-message" *ngIf="exceptionMessage != ''" [@inOutAnimation]>{{exceptionMessage}}</span>
            </div>
            <label class="label-left">Ingresa el dominio de tu tienda</label>
            <input type="text" class="textInput" (input)="exceptionMessage = ''" placeholder="Ej: tienda.com" formControlName="givenInsertedShop">
          </div>
            <div class="loading" *ngIf="loading">
            <div class="spinner-border" role="status"></div>
          </div>
          <div class="form-buttons d-flex" *ngIf="!loading">
            <button type="button" (click)="prevStep($event)" class="submit-btn">Anterior</button>
            <button type="button" (click)="nextStep($event)" class="submit-btn">Siguiente</button><br>
          </div>
        </form>
      </div> -->
    </div>
  </div>
  <!-- <div class="card" *ngIf="currentStep === 3">
    <div class="illustration">
      <img src="../../../assets/illustrations/moby-sign-in.png" />
    </div>
    <div class="form" *ngIf="!needsNewPassword; else ChangePasswordRequest" [@inOutAnimation]>
      <h2>INICIAR SESIÓN</h2>
      <form action="post" [formGroup]="signInForm" (ngSubmit)="onSignIn()">
        <div class="form-group">
          <div class="alert-span-exeption">
            <span class="error-message" *ngIf="exceptionMessage != ''" [@inOutAnimation]>{{exceptionMessage}}</span>
          </div>
          <div class="password-input">
            <input [type]="isPasswordVisible ? 'text':'password'" name="password" placeholder="Tu contraseña"
              class="textInput" formControlName="givenPassword" (focus)="exceptionMessage = ''">
            <i class="password-icon" [ngClass]="isPasswordVisible ? 'hide-password' : 'show-password'"
              (click)="isPasswordVisible = !isPasswordVisible"></i>
          </div>
          <a class="a-link a-password-recovery" (click)="recoveryPassword()">Olvidé mi contraseña</a>
        </div>
        <div class="form-buttons d-flex">
          <button type="button" (click)="prevStep($event)" class="submit-btn">Anterior</button>
          <button type="submit" [disabled]="isStepInvalid()" class="submit-btn">Iniciar sesión</button><br>
        </div>
      </form>
    </div>
  </div> -->
  <div class="card" *ngIf="currentStep === 2">
    <div class="illustration">
      <img src="../../../assets/illustrations/moby-sign-in.png" />
    </div>
    <div class="form" [@inOutAnimation]>
      <h2 class="text-center">CÓDIGO DE VERIFICACIÓN </h2>
      <svg xmlns="http://www.w3.org/2000/svg" width="130" height="130" viewBox="0 0 48 48">
        <path fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round" d="M24 43.5c9.043-3.117 15.489-10.363 16.5-19.589c.28-4.005.257-8.025-.071-12.027a2.54 2.54 0 0 0-2.468-2.366c-4.091-.126-8.846-.808-12.52-4.427a2.05 2.05 0 0 0-2.881 0c-3.675 3.619-8.43 4.301-12.52 4.427a2.54 2.54 0 0 0-2.468 2.366A79.4 79.4 0 0 0 7.5 23.911C8.512 33.137 14.957 40.383 24 43.5"/><path fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round" d="M17.612 19.804h12.776c.484 0 .877.392.877.877v9.442a.877.877 0 0 1-.877.877H17.612a.877.877 0 0 1-.877-.877V20.68c0-.485.393-.878.877-.878"/><path fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round" d="M19.192 19.804V17.79a4.805 4.805 0 0 1 9.608 0v2.014"/><circle cx="23.996" cy="25.402" r="1.863" fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <form>
        <div class="form-group">
          <input type="text" [(ngModel)]="verificationCode"name="verificationCode"class="textInput"placeholder="Código de autenticación"required/>
        </div>
        <div class="form-buttons d-flex justify-contents-eveenly mt-2">
          <button type="button" (click)="prevStep($event)" class="submit-btn">Anterior</button>
          <button type="button" class="submit-btn" (click)="nextStep($event)">Verificar</button>
        </div>
        <p class="error-message text-center mt-4" *ngIf="exceptionMessage">{{ exceptionMessage }}</p>
      </form>
    </div>
  </div>
</section>
<ng-template #ChangePasswordRequest>
  <div class="form" [@inOutAnimation]>
    <h2>CAMBIAR CONTRASEÑA</h2>
    <label class="info-message">Es necesario cambiar su contraseña al iniciar sesión por primera vez</label>
    <form action="post" [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword()">
      <div class="form-group">
        <div class="alert-span-exeption">
          <span *ngIf="exceptionMessage != ''" [@inOutAnimation] class="error-message">{{exceptionMessage}}</span>
        </div>
        <div class="alert-span"
          *ngIf="changePasswordFormValidation['newPassword'].touched && changePasswordFormValidation['newPassword'].invalid">
          <label class="error-message"
            *ngIf="changePasswordFormValidation['newPassword'].touched && changePasswordFormValidation['newPassword'].errors && changePasswordFormValidation['newPassword'].errors['required']"
            [@inOutAnimation]>
            Este campo es requerido
          </label>
          <label class="error-message"
            *ngIf="changePasswordFormValidation['newPassword'].touched && changePasswordFormValidation['newPassword'].errors && changePasswordFormValidation['newPassword'].errors['pattern']"
            [@inOutAnimation]>
            Formato incorrecto
          </label>
        </div>
        <div class="password-input">
          <input [type]="isPasswordVisible ? 'text':'password'" name="password" placeholder="Tu contraseña"
            class="textInput" formControlName="newPassword" (focus)="exceptionMessage = ''">
          <i class="password-icon" [ngClass]="isPasswordVisible ? 'hide-password' : 'show-password'"
            (click)="isPasswordVisible = !isPasswordVisible"></i>
        </div>
        <div class="alert-span">
          <span>La contraseña debe contener:</span>
          <ul>
            <li><span>Una longitud de 8 a 16 carácteres</span></li>
            <li><span>Al menos una letra en mayúscula</span></li>
            <li><span>Al menos una letra en minúscula</span></li>
            <li><span>Un número</span></li>
          </ul>
        </div>

        <div class="alert-span"
          *ngIf="changePasswordFormValidation['confirmNewPassword'].touched && changePasswordFormValidation['confirmNewPassword'].invalid">
          <label class="error-message"
            *ngIf="changePasswordFormValidation['confirmNewPassword'].errors && changePasswordFormValidation['confirmNewPassword'].errors['required']"
            [@inOutAnimation]>
            Este campo es requerido
          </label>
          <label class="error-message"
            *ngIf="changePasswordFormValidation['confirmNewPassword'].errors && changePasswordFormValidation['confirmNewPassword'].errors['matching']"
            [@inOutAnimation]>
            Las contraseñas no coinciden
          </label>
        </div>
        <div class="password-input">
          <input [type]="isConfirmPasswordVisible ? 'text':'password'" name="confirmNewPassword"
            placeholder="Confirma tu contraseña" class="textInput" formControlName="confirmNewPassword"
            (focus)="exceptionMessage = ''">
          <i class="password-icon" [ngClass]="isConfirmPasswordVisible ? 'hide-password' : 'show-password'"
            (click)="isConfirmPasswordVisible = !isConfirmPasswordVisible"></i>
        </div>
      </div>
      <div class="form-buttons d-flex-column password-form">
        <button type="submit" [disabled]="changePasswordForm.invalid" class="submit-btn">Iniciar sesión</button><br>
      </div>
    </form>
  </div>

</ng-template>
